import React from "react";
import { Phone, Mail } from "lucide-react";
import { PHONE, EMAIL } from "../mock";

export const ContactLink = ({
  kind = "phone", testId, variant = "inline", inverse = false,
  national = false, label, text, className = "", style, onClick,
}) => {
  const isPhone = kind === "phone";
  const Icon = isPhone ? Phone : Mail;
  const href = isPhone ? `tel:${PHONE.replace(/\s/g, "")}` : `mailto:${EMAIL}`;
  const [country, number] = PHONE.split(/\s+/, 2);

  return (
    <a href={href} data-testid={testId} onClick={onClick} style={style}
       aria-label={isPhone ? `Call Kapatia on ${PHONE}` : `Email Kapatia at ${EMAIL}`}
       className={`kp-contact-link kp-contact-${kind} kp-contact--${variant} inline-flex ${inverse ? "kp-contact--inverse" : ""} ${className}`}>
      <span className="kp-contact-icon" aria-hidden="true">
        <Icon size={20} strokeWidth={2} />
      </span>
      <span className="kp-contact-copy">
        {label && <span className="kp-contact-label" data-testid={`${testId}-label`}>{label}</span>}
        <span className="kp-contact-value" data-testid={`${testId}-value`}>
          {text || (isPhone ? <>
            {!national && <span className="kp-contact-country">{country}</span>}
            <span className="kp-contact-number">{number}</span>
          </> : EMAIL)}
        </span>
      </span>
    </a>
  );
};